// src/components/SubjectField.js
import React from "react";
import { Box, InputBase, Typography, FormHelperText } from "@mui/material";
import SubjectIcon from "@mui/icons-material/Subject";

const SubjectField = ({
    aiSuggestions,
    aiSuggestionsVisible,
    ticketData,
    isEditing,
    setIsEditing,
    handleChange,
    handleBlur,
    handleAIMessageForm
}) => {

    

    return (
        <div
            className={`ai-div ${aiSuggestions.subject && aiSuggestionsVisible.subject ? "ai-border" : ""
                }`}
        >
            <Box sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}>
                <SubjectIcon />
                {isEditing ? (
                    <InputBase
                        name="subject"
                        sx={{
                            ml: 1,
                            flex: 1,
                            fontWeight: "bold",
                            fontSize: 18,
                            borderBottom: "1px solid #ccc",
                            "&:focus": {
                                borderBottom: "2px solid #1976d2",
                            },
                        }}
                        placeholder="Enter Subject"
                        value={ticketData.subject}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        maxLength={255}
                        autoFocus
                    />
                ) : (
                    <Typography
                        variant="h6"
                        sx={{
                            ml: 1,
                            flex: 1,
                            fontSize: 18,
                            cursor: "pointer",
                        }}
                        onClick={() => setIsEditing(true)}
                    >
                        {ticketData.subject || "Enter Subject"}
                    </Typography>
                )}
            </Box>

            {aiSuggestions.subject && (
                <FormHelperText sx={{ color: "primary.main", mt: 0.5 }}>
                    💡 AI suggest:
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleAIMessageForm("subject")}
                    >
                        {aiSuggestions.subject}
                    </span>
                </FormHelperText>
            )}
        </div>
    );
};

export default SubjectField;
